import { useTranslation } from "react-i18next";
import { trackDownloadClick } from "screens/confirmation/tracking";
import { QrCode } from "./qrcode";
import { WEB_CONFIRMATION_EXP, MOBILE_CONFIRMATION_EXP } from "settings";
import { useExperimentValues } from "hooks/experiments/use-experiment-values";
import {
  AppStoreImage,
  ContainerExp,
  GooglePlayImage,
  Link,
  LinksExp,
} from "./styles";

export function Download() {
  const { t } = useTranslation("screens", {
    keyPrefix: "confirmation.download",
  });
  const webExpValues = useExperimentValues(WEB_CONFIRMATION_EXP);
  const mobileExpValues = useExperimentValues(MOBILE_CONFIRMATION_EXP);

  const isDesktopExperiment = webExpValues?.groupName;
  const bulleted = mobileExpValues?.value.bulleted as boolean;

  return (
    <ContainerExp>
      {isDesktopExperiment ? (
        <QrCode />
      ) : (
        <div>
          <LinksExp>
            <Link
              href={bulleted ? t("linkB") : t("linkC")}
              onClick={() => {
                trackDownloadClick("apple");
              }}
              {...{ target: "_blank" }}
            >
              <AppStoreImage />
            </Link>
            <Link
              href={bulleted ? t("linkB") : t("linkC")}
              onClick={() => {
                trackDownloadClick("other");
              }}
              {...{ target: "_blank" }}
            >
              <GooglePlayImage />
            </Link>
          </LinksExp>
        </div>
      )}
    </ContainerExp>
  );
}
